<template>
    <div class="d-flex flex-row mb-3 pb-3 border-bottom">
        <img :src="'/storage/images/users/' + data.data.attributes.posted_by.data.attributes.image"
             :alt="data.data.attributes.posted_by.data.attributes.name"
             class="img-thumbnail border-0 rounded-circle list-thumbnail xsmall"/>

        <div class="w-100 d-flex flex-row justify-content-between">
            <div class="ml-2 w-80">
                <p class="font-weight-medium mb-1">{{ data.data.attributes.comment }}</p>
                <p class="text-muted mb-0 text-small">
                    {{ data.data.attributes.posted_by.data.attributes.name + ' | ' + data.data.attributes.posted_at }}
                </p>
            </div>

            <div v-if="validateAuthUser(data)">
                <b-button size="sm" variant="outline-primary" class="icon-button-small"
                          @click="$emit('edit', data.comment_id)">
                    <i class="simple-icon-pencil"/>
                </b-button>

                <b-button size="sm" variant="outline-danger" class="ml-1 icon-button-small"
                          @click="$emit('delete', data.comment_id)">
                    <i class="simple-icon-trash"/>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: "CommentsList",

    props: ['data'],

    computed: {
        ...mapGetters({
            user: 'authUserInfo',
        }),
    },

    methods: {
        validateAuthUser(comment) {
            return comment.data.attributes.posted_by.data.attributes.name === this.user.attributes.name &&
                comment.data.attributes.comment.charAt(0) !== '[';
        },
    },
}
</script>
